<template>
  <div>
    <div v-if="loading" class="skeleton" :class="{ animate: animate }">
      <div
        v-if="showAvatar"
        class="skeleton-avatar"
        :class="[avatarShape]"
        :style="{ width: avatarSize, height: avatarSize }"
      ></div>
      <div class="skeleton-content">
        <div v-if="showTitle" class="skeleton-title" :style="{ width: titleWidth }"></div>
        <div class="skeleton-rows">
          <div
            class="skeleton-row-item"
            v-for="(item, index) in rowList"
            :key="index"
            :style="{ width: item.width }"
          ></div>
        </div>
      </div>
    </div>
    <div v-else><slot></slot></div>
  </div>
</template>


<script>

// 属性名	   类型	    默认值	说明
// loading	    Boolean	true	是否显示占位图
// showAvatar	Boolean	false	是否显示头像占位图
// avatarSize	String	50px	头像占位图大小
// avatarShape	String	round	头像形状，可选值：round, square
// showTitle	Boolean	false	是否显示标题占位图
// titleWidth	String	40%	     标题占位图宽度
// row        	Number	3	     段落占位图行数
// animate	    Boolean	true	  是否开启动画
const DEFAULT_ROW_WIDTH = '100%'
const DEFAULT_LAST_ROW_WIDTH = '60%'
export default {
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    showAvatar: {
      type: Boolean,
      default: false,
    },
    avatarSize: {
      type: String,
      default: '50px',
    },
    avatarShape: {
      type: String,
      default: 'round', // square | round
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    titleWidth: {
      type: String,
      default: '40%',
    },
    row: {
      type: Number,
      default: 3,
    },
    animate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    rowList() {
      let list = []
      for (let i = 0; i < this.row; i++) {
        list.push({
          width: i === this.row - 1 && i !== 0 ? DEFAULT_LAST_ROW_WIDTH : DEFAULT_ROW_WIDTH,
        })
      }
      return list
    },
  },
}
</script>

<style scoped>
.skeleton {
  display: flex;
  padding: 16px;
  --bg-color: #f2f3f5;
  --row-height: 16px;
  --row-margin-top: 16px;
}
.skeleton-avatar {
  flex-shrink: 0;
  background: var(--bg-color);
  margin-right: 8px;
}
.skeleton-avatar.round {
  border-radius: 50%;
}
.skeleton-content {
  width: 100%;
}
.skeleton-title {
  background-color: var(--bg-color);
  height: var(--row-height);
}
.skeleton-title + .skeleton-rows {
  margin-top: var(--row-margin-top);
}

.skeleton-row-item {
  background-color: var(--bg-color);
  height: var(--row-height);
}
.skeleton-row-item:not(:first-child) {
  margin-top: var(--row-margin-top);
}
.skeleton.animate {
  animation: skeleton-blink 1.2s ease-in-out infinite;
}
@keyframes skeleton-blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/base_package/Skeleton.vue